export default __webpack_public_path__ + "static/media/insync.a57dfedd.jpg";